import { createApp } from "vue";
import { createPinia } from "pinia";
import { PiniaColada } from "@pinia/colada";
import vuetify from "./plugins/vuetify";
import router from "./router";
import App from "./App.vue";

createApp(App)
    .use(router)
    .use(createPinia())
    .use(PiniaColada, { queryOptions: { staleTime: 30_000 } })
    .use(vuetify)
    .mount("#app");
